
export default function TestimonialsSection() {
  const testimonials = [
    {
      id: 1,
      name: '田中 美咲',
      age: 32,
      location: '渋谷区在住',
      service: 'マンション購入',
      rating: 5,
      comment: '初回の物件購入で不安でしたが、担当の方が親身になって相談に乗ってくださり、理想の住まいを見つけることができました。アフターサポートも充実していて安心です。',
      avatar: 'https://public.readdy.ai/ai/img_res/996b84f786743ac993721f27906b0e41.jpg.%20The%20photo%20should%20convey%20trustworthiness%20and%20satisfaction%2C%20suitable%20for%20a%20customer%20testimonial.%20High-quality%20portrait%20photography%20with%20soft%2C%20natural%20lighting.&width=80&height=80&seq=testimonial-1&orientation=squarish'
    },
    {
      id: 2,
      name: '佐藤 健一',
      age: 45,
      location: '世田谷区在住',
      service: '一戸建て売却',
      rating: 5,
      comment: '相続した実家の売却を依頼しました。市場価格の分析から販売戦略まで、プロフェッショナルな対応で想定以上の価格で売却できました。地域に詳しいからこその提案に感謝しています。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20confident%20Japanese%20businessman%20in%20his%20mid-forties%2C%20wearing%20a%20suit%20and%20tie%20with%20a%20genuine%20smile%20against%20a%20clean%20background.%20The%20photo%20should%20convey%20reliability%20and%20business%20success%2C%20suitable%20for%20a%20customer%20testimonial.%20High-quality%20corporate%20portrait%20photography.&width=80&height=80&seq=testimonial-2&orientation=squarish'
    },
    {
      id: 3,
      name: '山田 由香',
      age: 28,
      location: '港区在住',
      service: '賃貸契約',
      rating: 5,
      comment: '転勤で急遽住まい探しが必要になりましたが、希望条件に合う物件をスピーディーに見つけていただきました。契約手続きもスムーズで、新生活を快適にスタートできました。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Japanese%20woman%20in%20her%20late%20twenties%2C%20wearing%20modern%20business%20attire%20with%20a%20warm%2C%20genuine%20smile%20against%20a%20clean%20background.%20The%20photo%20should%20convey%20youth%20and%20professionalism%2C%20suitable%20for%20a%20customer%20testimonial.%20High-quality%20portrait%20photography%20with%20natural%20lighting.&width=80&height=80&seq=testimonial-3&orientation=squarish'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            お客様の声
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            実際にご利用いただいたお客様からの体験談
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-4">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <h3 className="font-bold text-gray-900">
                    {testimonial.name}さん
                  </h3>
                  <p className="text-sm text-gray-600">
                    {testimonial.age}歳 / {testimonial.location}
                  </p>
                  <p className="text-sm text-blue-600 font-semibold">
                    {testimonial.service}
                  </p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, index) => (
                  <i key={index} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
              
              <p className="text-gray-600 leading-relaxed">
                "{testimonial.comment}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
